import React, { useState, useEffect , useMemo } from "react";
import styles from './ConnectCalenderV2.module.css'
import HeaderBar from "../HeaderBar/HeaderBar";
import NewModal from "../NewModal/NewModal";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import { useAgentStore } from "../../Store/agentDetailStore";
import { useDashboardStore } from "../../Store/agentZustandStore";
import axios from "axios";
import decodeToken from "../../lib/decodeToken";
import Loader from "../Loader/Loader";
import Loader2 from "../Loader2/Loader2";
import {
    fetchAgentDetailById,
    getAgentCalendarStatus,
    connectAgentCalendar,
    disconnectAgentCalendar,
} from "../../Store/apiStore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const ConnectCalenderV2 = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [provider, setProvider] = useState("");
    // ── ICS URL — HIDDEN (2 of 3). Restore with the card in the render and
    //    the `provider === "ics"` branch in handleConnect.
    // const [icsConnected, setIcsConnected] = useState(false);

    // Only one calendar provider (Google ↔ Apple) can be active at a time;
    // connecting one disconnects the other on the backend. Before that happens
    // we ask the user to confirm the switch. Holds the provider they want to
    // switch TO ("google" | "apple"), or null when no confirmation is pending.
    const [switchConfirm, setSwitchConfirm] = useState(null);

    // ── Apple / iCloud Calendar (CalDAV) state ──────────────────────────────
    const [appleModalOpen, setAppleModalOpen] = useState(false);
    const [appleEmail, setAppleEmail] = useState("");
    const [applePassword, setApplePassword] = useState("");
    const [appleConnected, setAppleConnected] = useState(false);
    const [appleConnectedEmail, setAppleConnectedEmail] = useState("");
    const [appleConnecting, setAppleConnecting] = useState(false);
    const [appleError, setAppleError] = useState("");

    // This agent's calendar as the backend sees it for the CALLER (owner or an
    // admin of the owner): who connected it and what the caller may do. null
    // until loaded, and for members who may not manage it (support → 403).
    // Connections are AGENT-WISE: connecting links this agent only.
    const [agentCal, setAgentCal] = useState(null);

    // Apple Calendar (iCloud) is only relevant to the Apple ecosystem, so the
    // tile is shown ONLY on Safari — iOS/iPadOS Safari and desktop (Mac) Safari.
    // On iOS every browser is WebKit, so Chrome (CriOS), Firefox (FxiOS), Edge
    // (EdgiOS), Opera (OPiOS) on iOS — and all Android browsers — are excluded.
    const isAppleBrowser = useMemo(() => {
        if (typeof navigator === "undefined") return false;
        const ua = navigator.userAgent || "";
        const vendor = navigator.vendor || "";
        const isIOSDevice =
            /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
        // iOS Safari only (exclude other iOS browsers, which carry their own token).
        const isIOSSafari =
            isIOSDevice &&
            /Safari/i.test(ua) &&
            !/CriOS|FxiOS|EdgiOS|OPiOS|OPT|mercury/i.test(ua);
        const isDesktopSafari =
            vendor === "Apple Computer, Inc." &&
            /Safari/i.test(ua) &&
            !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/i.test(ua);
        return isIOSSafari || isDesktopSafari;
    }, []);
    
    // Calendar states
    const [isLoading, setIsLoading] = useState(false);
    const [agentData, setAgentData] = useState(null);
    // ── Connected email — HIDDEN (2 of 3). Restore with the card block and
    //    the setUserEmail call in the calendar-status check.
    // const [userEmail, setUserEmail] = useState("");
    const [calendarConnected, setCalendarConnected] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token") || "";
    const decodeTokenData = decodeToken(token);
    const teamOwnerId = typeof window !== "undefined" ? localStorage.getItem("teamOwnerId") : null;
    const isTeamMember = !!teamOwnerId;
    const effectiveUserId = teamOwnerId || decodeTokenData?.id;
    const location = useLocation();
     const params = useParams();
    // Notification deep-links land here as /connect-calender2?...&agentId=<id>,
    // so read the query string too — not just route params / state / session.
    const queryParams = new URLSearchParams(location?.search || "");
    useEffect(() => {
        loadAgentData();
        checkGlobalCalendarStatus();
        checkAppleCalendarStatus();
    }, []);
const [agentDetails, setAgentDetail] = useState({
        agentId:
            location?.state?.agentId ||
            queryParams.get("agentId") ||
            sessionStorage.getItem("SelectAgentId"),
        bussinesId:
            location?.state?.bussinesId ||
            queryParams.get("bussinesId") ||
            queryParams.get("businessId") ||
            sessionStorage.getItem("SelectAgentBusinessId"),
        agentDetails: location?.state?.agentDetails,
    });

    const {  setAgentById, setCurrentAgentId, getAgentById } =
        useAgentStore();
 // Lifecycle email / deep-link CTAs land here cold with ?agentId= in the URL —
    // read it (and businessId if present) so the correct agent is used even when
    // navigation state / sessionStorage aren't set yet. Session persist below.
    const _query = new URLSearchParams(location.search);
    const bussinesId =
        location?.state?.bussinesId ||
        params?.bussinesId ||
        _query.get("bussinesId") ||
        _query.get("businessId") ||
        sessionStorage.getItem("SelectAgentBusinessId");
    const agentId =
        location?.state?.agentId ||
        params?.agentId ||
        _query.get("agentId") ||
        sessionStorage.getItem("SelectAgentId");
    const agentDetailsPayload = useMemo(
        () => ({ agentId, bussinesId }),
        [agentId, bussinesId]
    );
    
            useEffect(() => {
                // Only agentId is required — the backend fetches the agent by
                // agent_id alone (businessId is not used in the lookup). This lets
                // a cold lifecycle deep-link (/connect-calender2?agentId=…, with no
                // session/cache/businessId) still load the agent.
                if (!agentId) return;

                // SelectAgentRole belongs to whichever agent SelectAgentId named.
                // Opening this screen for a DIFFERENT agent (e.g. the Google
                // badge of another card) must drop it, or the agent page we
                // return to after Google renders this agent with the previous
                // agent's layout (a receptionist shown as Pounce).
                if (sessionStorage.getItem("SelectAgentId") !== String(agentId)) {
                    sessionStorage.removeItem("SelectAgentRole");
                }
                sessionStorage.setItem("SelectAgentId", agentId);
                if (bussinesId) sessionStorage.setItem("SelectAgentBusinessId", bussinesId);

                const load = async () => {
                    const cached = getAgentById(agentId);
                    if (cached) {
                        setCurrentAgentId(agentId);
                        setLoading(false);
                    }

                    try {
                        setLoading(true);
                        const response = await fetchAgentDetailById(agentDetailsPayload);
                        const agentInfo = response?.data;

                        let numbersArray = [];
                        const voipNumbersStr = agentInfo?.agent?.voip_numbers;
                        if (voipNumbersStr) {
                            try {
                                numbersArray = JSON.parse(voipNumbersStr);
                            } catch { }
                        }

                        setAgentById(agentId, agentInfo, numbersArray);
                        setCurrentAgentId(agentId);
                        // Populate the LOCAL agentData ONLY if the cache
                        // (loadAgentData) didn't already set it — so a cold arrival
                        // (empty cache) gets it from the API and the Connect button
                        // enables, while the warm flow keeps its cache value
                        // unchanged. Functional update = race-safe.
                        // …but only while that cache value is THIS agent. A value
                        // left from the previously opened agent must be replaced,
                        // or this screen shows and changes the wrong agent.
                        if (agentInfo?.agent) {
                            setAgentData((prev) =>
                                prev && prev.agent_id === agentInfo.agent.agent_id
                                    ? prev
                                    : agentInfo.agent
                            );
                        }
                    } catch (err) {
                        console.error("Failed to fetch agent details:", err);
                    } finally {
                        setLoading(false);
                    }
                };

                load();
            }, [
                agentId,
                bussinesId,
                agentDetailsPayload,
                getAgentById,
                setAgentById,
                setCurrentAgentId,
            ]);
    const loadAgentCalendarStatus = async () => {
        if (!agentId) return;
        try {
            setAgentCal(await getAgentCalendarStatus(agentId));
        } catch (err) {
            setAgentCal(null);
        }
    };
    useEffect(() => {
        loadAgentCalendarStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agentId]);

    const loadAgentData = () => {
        try {
            const multiAgentCache = sessionStorage.getItem("multiAgentCache");
            if (multiAgentCache) {
                const cacheData = JSON.parse(multiAgentCache);
                // The agent this screen was opened FOR — not sessionStorage's
                // SelectAgentId, which on mount can still be the previously
                // opened agent (it is only updated by a later effect).
                const selectedAgentId = agentId;
                
                if (selectedAgentId && cacheData.data && cacheData.data[selectedAgentId]) {
                    const agent = cacheData.data[selectedAgentId].agentData.agent;
                    setAgentData(agent);
                }
            }
        } catch (error) {
            console.error("Error loading agent data:", error);
        }
    };

    const checkGlobalCalendarStatus = async () => {
        try {
            const res = await axios.post(`${API_BASE_URL}/calender-check`, {
                userId: effectiveUserId
            });

            const isConnected = res.data.connected === "true" || res.data.connected === true;
            setCalendarConnected(isConnected);
            sessionStorage.setItem("calenderConnect", isConnected.toString());

            // ── Connected email — HIDDEN (3 of 3). Restore with the state
            //    declaration and the <p className={styles.connectedEmail}>
            //    block in the Google Calendar card.
            // Email of the account the calendar was actually connected with
            // (owner's Google account). Falls back to empty so the UI hides
            // the row instead of leaking the logged-in viewer's email.
            // setUserEmail(isConnected ? (res.data.email || "") : "");
        } catch (err) {
            console.error("Calendar status check error:", err);
        }
    };

    // ── Apple / iCloud Calendar handlers ────────────────────────────────────
    const checkAppleCalendarStatus = async () => {
        try {
            const res = await axios.post(`${API_BASE_URL}/apple-calendar/status`, {
                userId: effectiveUserId,
            });
            if (res.data?.connected) {
                setAppleConnected(true);
                setAppleConnectedEmail(res.data?.connection?.appleEmail || "");
            } else {
                setAppleConnected(false);
                setAppleConnectedEmail("");
            }
        } catch (err) {
            console.error("Apple calendar status check error:", err);
        }
    };

    const handleAppleConnect = async () => {
        setAppleError("");
        if (!appleEmail.trim() || !applePassword.trim()) {
            setAppleError("Please enter your Apple ID email and app-specific password.");
            return;
        }
        try {
            setAppleConnecting(true);
            const res = await axios.post(`${API_BASE_URL}/apple-calendar/connect`, {
                userId: effectiveUserId,
                appleEmail: appleEmail.trim(),
                appPassword: applePassword.trim(),
            });
            if (res.data?.connection) {
                setAppleConnected(true);
                setAppleConnectedEmail(res.data.connection.appleEmail || appleEmail.trim());
                setAppleModalOpen(false);
                setApplePassword("");
                // Backend auto-disconnects Google when Apple connects — re-pull
                // the Google status so its tile flips to "Not Connected".
                checkGlobalCalendarStatus();
            }
        } catch (err) {
            const msg =
                err?.response?.data?.error ||
                "Could not connect Apple Calendar. Check your Apple ID and app-specific password.";
            setAppleError(msg);
        } finally {
            setAppleConnecting(false);
        }
    };

    const handleAppleDisconnect = async () => {
        try {
            setAppleConnecting(true);
            await axios.post(`${API_BASE_URL}/apple-calendar/disconnect`, {
                userId: effectiveUserId,
            });
            setAppleConnected(false);
            setAppleConnectedEmail("");
        } catch (err) {
            console.error("Apple calendar disconnect error:", err);
        } finally {
            setAppleConnecting(false);
        }
    };

    // Update sessionStorage with new calendarId
    const updateSessionStorage = (calendarId) => {
        try {
            const multiAgentCache = sessionStorage.getItem("multiAgentCache");
            if (multiAgentCache) {
                const cacheData = JSON.parse(multiAgentCache);
                // The agent this screen was opened FOR — not sessionStorage's
                // SelectAgentId, which on mount can still be the previously
                // opened agent (it is only updated by a later effect).
                const selectedAgentId = agentId;
                
                if (selectedAgentId && cacheData.data && cacheData.data[selectedAgentId]) {
                    // Update calendarId in cache
                    cacheData.data[selectedAgentId].agentData.agent.calendarId = calendarId;
                    
                    // Save back to sessionStorage
                    sessionStorage.setItem("multiAgentCache", JSON.stringify(cacheData));
                    
                    // Update local state
                    const updatedAgent = cacheData.data[selectedAgentId].agentData.agent;
                    setAgentData(updatedAgent);
                }
            }
        } catch (error) {
            console.error("Error updating sessionStorage:", error);
        }
    };

    // Server truth when we have it (the cached agent can be stale after a
    // connect made elsewhere), else the cached agent.
    const isAgentLinked = agentCal
        ? agentCal.agentLinked
        : agentData?.calendarId ? true : false;

    // What the caller may do with THIS agent's Google calendar (decided by the
    // backend): the owner may connect / disconnect any agent; an admin may
    // connect an agent that has none and disconnect one an admin connected —
    // never one the owner connected. Support members get no status → locked.
    // (No status for an owner = older backend; the owner is never locked.)
    const canManageGoogle = agentCal
        ? (isAgentLinked ? agentCal.canDisconnect : agentCal.canConnect)
        : !isTeamMember;
    const googleLocked = !canManageGoogle;
    const googleLockReason = !googleLocked
        ? undefined
        : agentCal
            ? (isAgentLinked
                ? "This calendar was connected by the account owner. Only the owner can change it."
                : "The account owner's calendar is already connected.")
            : "Only the account owner or an admin can manage the calendar connection";

    const handleGoogleConnect = async () => {
        setIsLoading(true);

        try {
            if (agentCal) {
                // Owner and admin alike: a Google consent for THIS agent only.
                if (agentCal.canConnect) await connectAgentCalendarOnly();
            } else if (isTeamMember) {
                // No status → not allowed to manage this agent's calendar.
            } else if (calendarConnected && !isAgentLinked) {
                // Older backend (no agent-calendar status): previous behaviour.
                await linkAgentToCalendar(agentData);
            } else if (!calendarConnected) {
                await connectGlobalCalendar();
            }
        } catch (err) {
            console.error("Connection error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // const connectGlobalCalendar = async () => {
    //     const userId = decodeTokenData?.id;
    //     const res = await axios.post(`${API_BASE_URL}/connect`, { userId });

    //     if (res.data?.authUrl) {
    //         setIsModalOpen(false);
    //         window.location.href = res.data.authUrl;
    //     }
    // };


    const connectGlobalCalendar = async () => {
        const userId = decodeTokenData?.id;
        // Inside the RN WebView, flag the request so the calendar callback
        // redirects via the com.rexptin://calendar deep link (Android intent://
        // + iOS scheme, both handled by the backend) instead of the web URL —
        // and hand the auth URL to native so OAuth opens in the InAppBrowser,
        // NOT this embedded WebView (Google blocks OAuth in embedded webviews).
        const isRN = !!window.ReactNativeWebView;
        const res = await axios.post(`${API_BASE_URL}/connect`, {
            userId,
            isMobile: isRN,
            ...(agentId ? { agentId } : {}),
            // [FIX: origin-redirect] — do frontend (3000/3001, live app.rexpt.in/
            // app.rxpt.ai) me callback wapas usi frontend pe laane ke liye origin bhejo.
            // REVERT: neeche wali `origin:` line hata do.
            origin: window.location.origin,
        });

        const authUrl = res?.data?.authUrl;
        if (authUrl) {
            setIsModalOpen(false);
            if (isRN) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "OPEN_GOOGLE_AUTH", authUrl, flow: "calendar" })
                );
            } else {
                window.location.href = authUrl;
            }
        }
    };
    
    const agentCalendarName = (agent) =>
        `REXPT: ${agent?.agentName} ${agent?.business?.businessName || agent?.businessDetails?.name || ''} Meetings`;

    // Google consent for THIS agent only. The grant is stored against the
    // agent, so no other agent is linked by it.
    const connectAgentCalendarOnly = async () => {
        const isRN = !!window.ReactNativeWebView;
        const res = await connectAgentCalendar({
            agentId,
            isMobile: isRN,
            origin: window.location.origin,
        });
        const authUrl = res?.authUrl;
        if (authUrl) {
            setIsModalOpen(false);
            if (isRN) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "OPEN_GOOGLE_AUTH", authUrl, flow: "calendar" })
                );
            } else {
                window.location.href = authUrl;
            }
        }
    };

    const linkAgentToCalendar = async (agent) => {
        try {
            const res = await axios.post(`${API_BASE_URL}/create-agent-calender`, {
                agentId: agent?.agent_id,
                timeZone: agent?.timezone,
                calendarName: agentCalendarName(agent)
            });

            setIsModalOpen(false);
            
            // Extract calendarId from response
            const newCalendarId = res.data?.calendarId || res.data?.data?.calendarId;
            
            if (newCalendarId) {
                // Update sessionStorage immediately
                updateSessionStorage(newCalendarId);
            }
            loadAgentCalendarStatus();
            
        } catch (error) {
            console.error("Link calendar error:", error);
        }
    };

    const handleDisconnect = async () => {
        try {
            setIsLoading(true);
            // `agentId` (outer) = the agent this screen was opened for. Never
            // take it from a cached record, which could be another agent's.

            // The agent's OWN connection is removed through the authenticated
            // endpoint; an agent still on the owner's account calendar (linked
            // before connections were agent-wise) keeps the existing unlink.
            const res = agentCal?.agentConnection && !agentCal.agentConnection.legacy
                ? { data: await disconnectAgentCalendar(agentId) }
                : await axios.delete(`${API_BASE_URL}/calendar-delete`, {
                    data: { agentId }
                });

            if (res.data) {
                // Set calendarId to null in sessionStorage
                updateSessionStorage(null);
            }
            // Dashboard cards read calendarId from their cached agent list.
            useDashboardStore.getState().setHasFetched(false);
            await loadAgentCalendarStatus();
        } catch (err) {
            console.error("Disconnect error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpenModal = (type) => {
        setProvider(type);
        setIsModalOpen(true);
    };

    const handleConnect = () => {
        if (provider === "google") {
            handleGoogleConnect();
        }
        // ── ICS URL — HIDDEN (3 of 3). Unreachable while the card is hidden
        //    (handleOpenModal("ics") was its only caller). Restore with (1)+(2).
        // else if (provider === "ics") {
        //     setIcsConnected(true);
        //     setIsModalOpen(false);
        // }
    };
    // Agent load hone tak: header aur text asli, sirf calendar card ki jagah
    // usi size ka shimmer — poore page ka loader nahi.
    if (loading) {
        return (
            <div className={styles.ConatinerBox}>
                <HeaderBar title="Connect Calendar" />
                <div className={styles.container}>
                    <div>
                        <p className={styles.TopPara}>
                            You can easily{" "}
                            <strong>Connect your personal or business Calendar</strong> with your{" "}
                            <a href="#">Rexptin Agent</a> to receive calendar Meetings.
                        </p>
                    </div>
                    <div className={styles.ConnectDiv} aria-busy="true" aria-label="Loading calendar">
                        <div className={styles.card}>
                            <div className={styles.left}>
                                <div className={`${styles.shimmer} ${styles.skeletonIcon}`} />
                                <div>
                                    <div className={`${styles.shimmer} ${styles.skeletonTitle}`} />
                                    <div className={`${styles.shimmer} ${styles.skeletonStatus}`} />
                                </div>
                            </div>
                            <div className={`${styles.shimmer} ${styles.skeletonBtn}`} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <>
            <div className={styles.ConatinerBox}>
                <HeaderBar title="Connect Calendar" />
                <div className={styles.container}>
                    <div>
                        <p className={styles.TopPara}>
                            You can easily{" "}
                            <strong>Connect your personal or business Calendar</strong> with your{" "}
                            <a href='#'>Rexptin Agent</a> to receive calendar Meetings.
                        </p>
                    </div>
                    
                    <div className={styles.ConnectDiv}>
                        {/* Google Calendar */}
                        <div className={styles.card}>
                            <div className={styles.left}>
                                <div className={styles.iconWrapper}>
                                    <img src="/svg/google_calendar.svg" alt="Google Calendar" />
                                    <span className={styles.closeIcon}>
                                        <img
                                            src={
                                                isAgentLinked
                                                    ? "/svg/check-circle-fill.svg"
                                                    : "/svg/x-circle-fill2.svg"
                                            }
                                            alt="status"
                                        />
                                    </span>
                                </div>

                                <div>
                                    <h4>Google Calendar</h4>
                                    <p
                                        className={
                                            isAgentLinked
                                                ? styles.statusConnected
                                                : styles.statusNotConnected
                                        }
                                    >
                                        {isAgentLinked ? "Connected" : "Not Connected"}
                                    </p>
                                    {/* Connected for this agent only — say whose
                                        Google account it is. */}
                                    {isAgentLinked && agentCal?.agentConnection && !agentCal.agentConnection.legacy && (
                                        <p className={styles.connectedEmail}>
                                            {agentCal.agentConnection.googleEmail || "Google account"}
                                            {agentCal.agentConnection.connectedByMe
                                                ? " · connected by you"
                                                : agentCal.agentConnection.connectedByName
                                                    ? ` · connected by ${agentCal.agentConnection.connectedByName}`
                                                    : ""}
                                        </p>
                                    )}
                                    {/* ── Connected email — HIDDEN (1 of 3) ──────────
                                        Removed on request: the card showed the ACCOUNT
                                        login email, not the Google account the calendar
                                        is actually linked to. "Connected" alone is the
                                        status this card exists to give.
                                        The `userEmail` state (2) and its setter (3) are
                                        commented out with it so no binding is left
                                        unused — Vercel builds CRA with CI=true, where a
                                        lint warning fails the build. Restore all three.
                                    {isAgentLinked && userEmail && (
                                        <p className={styles.connectedEmail}>
                                            {userEmail}
                                        </p>
                                    )} */}
                                </div>
                            </div>

                            <button
                                className={
                                    isAgentLinked
                                        ? styles.disconnectBtn
                                        : styles.connectBtn
                                }
                                onClick={() => {
                                    if (googleLocked) return;
                                    if (isAgentLinked) {
                                        handleDisconnect();
                                    } else if (appleConnected && !isTeamMember) {
                                        // Apple already on — confirm before switching.
                                        setSwitchConfirm("google");
                                    } else {
                                        handleOpenModal("google");
                                    }
                                }}
                                disabled={isLoading || !agentData || googleLocked}
                                title={googleLockReason}
                                style={googleLocked ? { opacity: 0.6, cursor: "not-allowed", display: "flex", alignItems: "center", gap: 6 } : undefined}
                            >
                                {isLoading ? (
                                    <Loader size={16} />
                                ) : (
                                    <>
                                        {googleLocked && (
                                            <img src="/svg/cta_lock.svg" alt="locked" style={{ width: 14, height: 14 }} />
                                        )}
                                        {isAgentLinked ? "Disconnect" : "Connect"}
                                    </>
                                )}
                            </button>
                        </div>

                        {/* ── ICS URL — HIDDEN (1 of 3) ─────────────────────────
                            Card commented out on request. Two companion blocks
                            are commented out with it so no binding is left
                            unused (CRA treats lint warnings as errors when the
                            build runs with CI=true):
                              (2) the `icsConnected` state declaration
                              (3) the `provider === "ics"` branch in handleConnect
                            Restore all three together. The modal's
                            `provider === "ics"` copy below is left in place —
                            it is unreachable while this card is hidden, and
                            references no ICS state.
                        ───────────────────────────────────────────────────── */}
                        {/*
                        <div className={styles.card}>
                            <div className={styles.left}>
                                <div className={styles.iconWrapper}>
                                    <img src="/svg/ics.svg" alt="ICS" />
                                    <span className={styles.closeIcon}>
                                        <img
                                            src={
                                                icsConnected
                                                    ? "/svg/check-circle-fill.svg"
                                                    : "/svg/x-circle-fill2.svg"
                                            }
                                            alt="status"
                                        />
                                    </span>
                                </div>

                                <div>
                                    <h4>ICS URL</h4>
                                    <p
                                        className={
                                            icsConnected
                                                ? styles.statusConnected
                                                : styles.statusNotConnected
                                        }
                                    >
                                        {icsConnected ? "Connected" : "Not Connected"}
                                    </p>
                                    {icsConnected && (
                                        <p className={styles.connectedEmail}>
                                            TestmailID123@gmail.com
                                        </p>
                                    )}
                                </div>
                            </div>

                            <button
                                className={
                                    icsConnected
                                        ? styles.disconnectBtn
                                        : styles.connectBtn
                                }
                                onClick={() => {
                                    if (isTeamMember) return;
                                    icsConnected
                                        ? setIcsConnected(false)
                                        : handleOpenModal("ics");
                                }}
                                disabled={isTeamMember}
                                title={isTeamMember ? "Only the account owner can manage the calendar connection" : undefined}
                                style={isTeamMember ? { opacity: 0.6, cursor: "not-allowed", display: "flex", alignItems: "center", gap: 6 } : undefined}
                            >
                                {isTeamMember && (
                                    <img src="/svg/cta_lock.svg" alt="locked" style={{ width: 14, height: 14 }} />
                                )}
                                {icsConnected ? "Disconnect" : "Connect"}
                            </button>
                        </div>
                        */}

                        {/* Apple / iCloud Calendar — shown only on Safari / iOS / Mac */}
                        {isAppleBrowser && (
                            <div className={styles.card}>
                                <div className={styles.left}>
                                    <div className={styles.iconWrapper}>
                                        <img src="/svg/apple.svg" alt="Apple Calendar" />
                                        <span className={styles.closeIcon}>
                                            <img
                                                src={
                                                    appleConnected
                                                        ? "/svg/check-circle-fill.svg"
                                                        : "/svg/x-circle-fill2.svg"
                                                }
                                                alt="status"
                                            />
                                        </span>
                                    </div>

                                    <div>
                                        <h4>Apple Calendar</h4>
                                        <p
                                            className={
                                                appleConnected
                                                    ? styles.statusConnected
                                                    : styles.statusNotConnected
                                            }
                                        >
                                            {appleConnected ? "Connected" : "Not Connected"}
                                        </p>
                                        {/* ── Connected email — HIDDEN ───────────────
                                            Removed on request, same as the Google
                                            Calendar card above: "Connected" alone is the
                                            status these cards exist to give.
                                            No companion blocks to comment out here —
                                            `appleConnectedEmail` is still read by the
                                            Apple modal's "connected as <email>" line, so
                                            nothing is left unused.
                                        {appleConnected && appleConnectedEmail && (
                                            <p className={styles.connectedEmail}>
                                                {appleConnectedEmail}
                                            </p>
                                        )} */}
                                    </div>
                                </div>

                                <button
                                    className={
                                        appleConnected ? styles.disconnectBtn : styles.connectBtn
                                    }
                                    onClick={() => {
                                        if (isTeamMember) return;
                                        if (appleConnected) {
                                            handleAppleDisconnect();
                                        } else if (calendarConnected) {
                                            // Google already on — confirm before switching.
                                            setSwitchConfirm("apple");
                                        } else {
                                            setAppleError("");
                                            setAppleModalOpen(true);
                                        }
                                    }}
                                    disabled={appleConnecting || isTeamMember}
                                    title={isTeamMember ? "Only the account owner can manage the calendar connection" : undefined}
                                    style={isTeamMember ? { opacity: 0.6, cursor: "not-allowed", display: "flex", alignItems: "center", gap: 6 } : undefined}
                                >
                                    {appleConnecting ? (
                                        <Loader size={16} />
                                    ) : (
                                        <>
                                            {isTeamMember && (
                                                <img src="/svg/cta_lock.svg" alt="locked" style={{ width: 14, height: 14 }} />
                                            )}
                                            {appleConnected ? "Disconnect" : "Connect"}
                                        </>
                                    )}
                                </button>
                            </div>
                        )}
                    </div>

                    {/* HIDDEN (2026-08-25): the "Or Connect With" block —
                        Outlook + Zoho provider tiles and the "Powered by Cal.com"
                        footer. Hidden on EVERY entry point into this screen (agent
                        card Connect, More menu → Connect Calendar), which is why
                        it is commented at the render site rather than gated on a
                        caller prop. Google Calendar and ICS URL above are
                        untouched. Restore by uncommenting — the /connectcal route
                        and both provider flows are left intact.

                    <div className={styles.connectWrapper}>
                        <div className={styles.connectCard}>
                            <div className={styles.connectHeadingRow}>
                                <p className={styles.connectHeadingText}>Or Connect With</p>
                            </div>

                            <div className={styles.connectProviders}>
                                <div className={styles.connectProviderItem} onClick={() =>
                                    navigate("/connectcal", {
                                        state: { provider: "outlook" },
                                    })
                                }>
                                    <img src="/svg/outlook.svg" alt="Outlook" />
                                    <span>Outlook</span>
                                </div>

                                <div className={styles.connectProviderItem} onClick={() =>
                                    navigate("/connectcal", {
                                        state: { provider: "zoho" },
                                    })
                                }>
                                    <img src="/svg/zoho.svg" alt="Zoho" />
                                    <span>Zoho</span>
                                </div>
                            </div>

                            <p className={styles.connectFooterText}>Powered by Cal.com</p>
                        </div>
                    </div>
                    */}
                </div>
            </div>

            {/* Modal */}
            <NewModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                bodyPadding="20px 20px 70px 20px"
                title={
                    provider === "google"
                        ? "Connect Google Calendar"
                        : "Connect ICS URL"
                }
                height="auto"
            >
                <div className={styles.modalBody}>
                    <img
                        src={
                            provider === "google"
                                ? "/svg/google_calendar.svg"
                                : "/svg/ics.svg"
                        }
                        alt="provider"
                        className={styles.modalIcon}
                    />

                    <p className={styles.modalText}>
                        {provider === "google" && (
                            <>
                                Connect your <b>Google Calendar</b> to sync all events
                                automatically.
                            </>
                        )}

                        {provider === "ics" && (
                            <>
                                Add your <b>ICS URL</b> to sync calendar events automatically.
                            </>
                        )}
                    </p>

                    <AnimatedButton
                        label={
                            isLoading ? "Connecting..." : (
                                provider === "google"
                                    ? "Continue with Google Calendar"
                                    : "Connect with ICS URL"
                            )
                        }
                        onClick={handleConnect}
                        disabled={isLoading}
                    />
                </div>
            </NewModal>

            {/* Apple / iCloud Calendar modal */}
            <NewModal
                isOpen={appleModalOpen}
                onClose={() => setAppleModalOpen(false)}
                bodyPadding="20px 20px 40px 20px"
                title={appleConnected ? "Apple Calendar Connected" : "Connect Apple Calendar"}
                height="auto"
            >
                <div className={styles.modalBody}>
                    <img src="/svg/apple.svg" alt="Apple" className={styles.modalIcon} />

                    {appleConnected ? (
                        <>
                            <p className={styles.modalText}>
                                Your iCloud calendar is connected
                                {appleConnectedEmail ? <> as <b>{appleConnectedEmail}</b></> : null}.
                            </p>
                            <AnimatedButton
                                label={appleConnecting ? "Disconnecting..." : "Disconnect Apple Calendar"}
                                onClick={handleAppleDisconnect}
                                disabled={appleConnecting}
                                positionType="relative"
                                bottom="0px"
                            />
                        </>
                    ) : (
                        <>
                            <p style={{ fontSize: "13px", color: "#666", margin: "0 0 10px" }}>
                                To generate an app-specific password, go to{" "}
                                <a
                                    href="https://account.apple.com/account/manage"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#2563eb", fontWeight: 600, textDecoration: "underline" }}
                                >
                                    appleaccount.com
                                </a>
                                , sign in and create an app-specific password.
                            </p>
                            <input
                                type="email"
                                placeholder="Apple ID email (e.g. you@icloud.com)"
                                value={appleEmail}
                                onChange={(e) => setAppleEmail(e.target.value)}
                                style={{ width: "100%", padding: "12px", margin: "8px 0", borderRadius: "8px", border: "1px solid #ddd" }}
                            />
                            <input
                                type="password"
                                placeholder="App-specific password (xxxx-xxxx-xxxx-xxxx)"
                                value={applePassword}
                                onChange={(e) => setApplePassword(e.target.value)}
                                style={{ width: "100%", padding: "12px", margin: "8px 0", borderRadius: "8px", border: "1px solid #ddd" }}
                            />

                            {appleError && (
                                <p style={{ color: "#d33", fontSize: "13px", margin: "4px 0 12px" }}>{appleError}</p>
                            )}

                            <AnimatedButton
                                label={appleConnecting ? "Connecting..." : "Connect Apple Calendar"}
                                onClick={handleAppleConnect}
                                disabled={appleConnecting}
                                positionType="relative"
                                bottom="0px"
                            />
                        </>
                    )}
                </div>
            </NewModal>

            {/* Switch-provider confirmation — connecting one calendar disconnects
                the other, so confirm before proceeding. */}
            <NewModal
                isOpen={!!switchConfirm}
                onClose={() => setSwitchConfirm(null)}
                bodyPadding="20px 20px 40px 20px"
                title="Switch Calendar?"
                height="auto"
            >
                <div className={styles.modalBody}>
                    <img
                        src={switchConfirm === "google" ? "/svg/google_calendar.svg" : "/svg/apple.svg"}
                        alt="provider"
                        className={styles.modalIcon}
                    />
                    <p className={styles.modalText}>
                        {switchConfirm === "google" ? (
                            <>Connecting <b>Google Calendar</b> will disconnect your currently
                            connected <b>Apple Calendar</b>. Do you want to continue?</>
                        ) : (
                            <>Connecting <b>Apple Calendar</b> will disconnect your currently
                            connected <b>Google Calendar</b>. Do you want to continue?</>
                        )}
                    </p>

                    <AnimatedButton
                        label={switchConfirm === "google" ? "Continue with Google Calendar" : "Continue with Apple Calendar"}
                        onClick={() => {
                            const target = switchConfirm;
                            setSwitchConfirm(null);
                            if (target === "google") {
                                handleOpenModal("google");
                            } else if (target === "apple") {
                                setAppleError("");
                                setAppleModalOpen(true);
                            }
                        }}
                        positionType="relative"
                        bottom="0px"
                    />
                    <button
                        type="button"
                        onClick={() => setSwitchConfirm(null)}
                        style={{
                            width: "100%",
                            marginTop: "10px",
                            padding: "12px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            background: "#fff",
                            color: "#444",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </NewModal>
        </>
    )
}

export default ConnectCalenderV2